import { lazy } from "react";

const AllPurchases = lazy(() => import("../../../pages/User/purchases/Purchases"));
const PurchasedAsset = lazy(() => import("../../../pages/User/purchases/ViewPurchases"));

export const purchaseRoutes = [
  { path: "purchases/:cat", element: <AllPurchases /> },
  { path: "purchases/:cat/:id/view", element: <PurchasedAsset /> },
];
